require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./about-our-vision-philosophy.json") })
        }
      }, "path---about-our-vision-philosophy");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---about-our-vision-philosophy!./.cache/json/about-our-vision-philosophy.json
// module id = 1221
// module chunks = 231608221292675